import { ArchVizApp } from "@/components/archviz/ArchVizApp";

export function ArchVizPage() {
  return <ArchVizApp />;
}
